import { useSystemStore } from '../stores/SystemStore';
import { useUserStore } from '../stores/UserStore';
import { trcpProxyClient } from '../utils/trcp';
import { useGroupSettings } from './useGroupSettings';

export const useActiveSchoolId = () => {
	const groupSettings = useGroupSettings();
	const activeSchoolId = useSystemStore(state => state.activeSchoolId);
	const setStoreFn = useSystemStore(state => state.setActiveSchoolId);
	const setIsGroupBlocked = useUserStore(state => state.setIsGroupBlocked);

	const refetchIsGroupBlocked = async (schoolId: string) => {
		const isGroupBlocked = await trcpProxyClient.user.getIsGroupBlocked.query({ schoolId });
		setIsGroupBlocked(isGroupBlocked);
	};

	const setActiveSchoolId = (id: string) => {
		setStoreFn(id);
		groupSettings.refetch();

		refetchIsGroupBlocked(id);
	};

	return {
		activeSchoolId,
		setActiveSchoolId,
	};
};
